<!--<ng-container *ngIf="loadingRow">
  <mat-spinner diameter="34"></mat-spinner>
</ng-container>-->
<ng-container *ngIf="openingEditPopup">
  <div class="spinner-overlay">
    <mat-spinner diameter="34"></mat-spinner>
  </div>
</ng-container>
<ng-container *ngIf="observations?.length">
  
  <tr *ngFor="let observation of observations; let i = index">
    <div class="spiner_loader" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
    </div>
    <td title="Click to edit Observation" (click)="openSchematicWindow(observation)" class="pointer pad0">
      <div class="column-merge">
        <div style="width: 150px;">

        </div>
        <div>
          <span> {{observation?.ComponentName }} </span>
        </div>
      </div>
    </td>
    <td title="Click to edit Observation" (click)="openSchematicWindow(observation)" class="pointer pad0">
      <span> {{observation?.PartNumber }} </span>
    </td>
    <td title="Click to edit Observation" (click)="openSchematicWindow(observation)" class="pointer pad0">
      <span> {{observation?.CNG }} </span>
    </td>
    <td title="Click to edit Observation" (click)="openSchematicWindow(observation)" class="pointer pad0">
      <span> {{observation?.Cmu}} </span>
    </td>
    <td title="Click to edit Observation" (click)="openSchematicWindow(observation)" class="pointer pad0"><span>{{observation.Residual}}</span></td>

    <td title="Click to edit Observation" (click)="openSchematicWindow(observation)" class="pointer pad0">{{observation.ObservationName}} </td>
    <td title="Click to edit Observation" (click)="openSchematicWindow(observation)" class="pointer pad0">{{observation.ObservationTypeName}} </td>
    <td *ngIf="observation.ObservationTypeName =='Evaluation' || observation.ObservationTypeName =='Selection' || observation.ObservationTypeName =='Pass/Fail' || observation.ObservationTypeName =='Yes/No'" class=" pad0">N/A </td>
    <td *ngIf="observation.ObservationTypeName !='Evaluation' && observation.ObservationTypeName !='Selection' && observation.ObservationTypeName !='Pass/Fail' && observation.ObservationTypeName !='Yes/No'" class=" pad0">
      <div style="display: flex; justify-content: space-between; width: 100%;">
        <div style="width: 50%;">{{observation.LimitNew}}</div>
        <div style="width: 50%;">{{observation.LimitScrap}}</div>
      </div>
    </td>
    <td class="margin-right pad0" style="vertical-align : middle;">
      <div class="observation-question" [class.ShouldHighLight]="shouldHighlight(observation)">
        <i title="Observation Questions" class="material-icons upload-container__icon" (click)="openQPopup(observation.QuestionTitle)">
          message
        </i>
      </div>
    </td>
    <td class=" pad0" style="vertical-align : middle;">
      <div class="observation-question" [class.ShouldHighLight]="shouldHighlightQandI(observation)">
        <i title="Question Image & Instructions" class="material-icons" (click)="openPopup(observation.QuestionInstruction,observation.ImagePath)">rate_review</i>
      </div>
    </td>
    <td class=" pad0"> <measurement-on-observation (measurementChanged)="measurementChanged($event)" [isCreatingInspection]="false" [observationPoint]="observation"></measurement-on-observation> </td>
    <td *ngIf="observation.ObservationTypeId !=3 && observation.ObservationTypeId!=4 && observation.ObservationTypeId!=5 && observation.ObservationTypeId!=6" class=" pad0">
      <div class="{{getEvalClass(observation.WornPercentage)}}  worn-percentage">
        {{observation.WornPercentage}} %
      </div>
    </td>
    <td *ngIf="observation.ObservationTypeId ==3 || observation.ObservationTypeId ==4 || observation.ObservationTypeId ==5 || observation.ObservationTypeId ==6" class=" pad0">
      <div class="{{getEvalClass2(observation.WornPercentage)}}  worn-percentage">
        {{getEvalCode(observation.WornPercentage)}}
      </div>
    </td>
    <td class="pad0">{{observation.LocationName}}</td>
    <td class=" pad0">
      <mat-form-field style="width: 85%;" *ngIf="observation.ObsList?.length">
        <!-- MULTI for normal observation  -->
        <mat-select *ngIf="observation.ObservationTypeName !== 'Crack'"
                    [(ngModel)]="observation.severityIDs"
                    [ngModelOptions]="{ standalone: true }"
                    multiple
                    (selectionChange)="updateObsSeverity(observation.Id, observation.severityIDs)"
                    (openedChange)="onOpened($event)">
          <mat-option *ngFor="let list of observation.ObsList" [value]="list.ID">
            {{ list.Name }}
          </mat-option>
        </mat-select>
        <!-- SINGLE for crack normal observation -->
        <mat-select *ngIf="observation.ObservationTypeName === 'Crack'"
                    [(ngModel)]="observation.obsId"
                    [ngModelOptions]="{ standalone: true }"
                    (selectionChange)="updateObsSeverity(observation.Id, observation.obsId)"
                    (openedChange)="onOpened($event)">

          <mat-option *ngFor="let list of observation.ObsList" [value]="list.ID">
            {{ list.Name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </td>
    <td class=" pad0">
      <!-- <mat-form-field style="width: 100px;" *ngIf="observation.obsSeverityList!=null && observation.obsSeverityList.length>0"> *ngIf="observation.ObservationTypeName =='Crack'" -->
      <mat-form-field style="width: 85%;" *ngIf="observation.obsSeverityList?.length && observation.ObservationTypeName =='Crack'">
        <mat-select [(ngModel)]="observation.severityID" (selectionChange)="updateCrackSeverity(observation.Id, observation.severityID)" (openedChange)="onOpened($event)">
          <mat-option *ngFor="let list of observation.obsSeverityList" [value]="list.ID">{{list.Name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <!--<div style="width: 100px;" *ngIf="observation.obsSeverityList.length==0 || observation.obsSeverityList.length==null">
    </div>-->
    </td>

    <td *ngIf="observation.Flag" class="pointer pad0" style="vertical-align : middle;"> <i title="Observation Flag" class="material-icons" (click)="ToggleObsFlag(observation.Id,false)" style="color: red;">flag</i></td>
    <td *ngIf="!observation.Flag" class="pointer pad0" style="vertical-align : middle;"> <i title="Observation Flag" class="material-icons" (click)="ToggleObsFlag(observation.Id,true)">flag</i></td>
    <td style="cursor: pointer;" [title]="(observation.ImageHistoryAvailable ? 'Images History' : 'No Images History') | translate | async">
      <app-component-image-history-button [module]="ModuleType.GET"
                                          [implementId]="implementID"
                                          [componentId]="0"
                                          [obsPointId]="observation.ObservationPointId"
                                          [imageHistoryAvailable]="observation.ImageHistoryAvailable">
      </app-component-image-history-button>
    </td>
    <td class="pad0 content-middle">
      <div class="flex-gap-5">
        <span *ngFor="let image of observation?.ObservationImages">
          <img class="observation-image__photo" (click)="viewObservationImages(image, observation)" *ngIf="image.ImageDataPath !== ''" [src]="image.ImageDataPath">
        </span>
        <span>
          <photos-modal [observationPoint]="observation" [ObservationPointId]="observation.Id" [comingFrom]="photoComingFrom" (onPhotoUpload)="photoRecevied($event, observation)"></photos-modal>
        </span>
      </div>
    </td>
    <td class=" pad0" style="vertical-align : middle;">
      <observation-comments #observationComment [observationPoint]="observation" [comingFrom]="commentComingFrom" (onCommentChange)="obsCommentChanged($event,observation)"></observation-comments>
    </td>
    <td class="pointer pad0" style="vertical-align : middle;"><i title="Delete Measurement" class="material-icons" (click)="DeleteObsMeasurement(observation)">delete</i></td>
    <td class="margin-right pad0">
      <mat-checkbox id="chkObservation-{{observation.Id}}" [checked]="observation?.IncludeReport" style="margin-left: 34%;" color="primary"
                    (change)="toggleObservationPointIncludeReport(observation.Id)">
      </mat-checkbox>

    </td>
  </tr>
</ng-container>

<div *ngIf="showPopup" class="modal-overlay" (click)="closePopup()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="ttmodal__header">
      <span class="ttmodal__title">Question Image & Instructions</span>
      <i class="material-icons ttmodal__close-button" (click)="closePopup()" title="Close">close</i>
    </div>
    <div class="upload-container" style="margin-top: 15px; text-align: center; padding: 20px; min-height: 150px;">
      <!--<input hidden type="file" (change)="onSelectModalImage($event)" #modalImageInput>-->
      <div *ngIf="!questionImage">
        <i class="material-icons upload-container__icon">add_a_photo</i>
      </div>
      <div *ngIf="questionImage" style="display: flex; align-items: center; justify-content: center;">
        <img [src]="questionImage" style="width: 60%; height: 60%; margin-right: 5px; cursor: pointer;" />
      </div>
    </div>
    <span class="ttmodal__title">Instructions</span>
    <span [innerText]="questionInstruction"
          style="display: inline-block; width: 100%; min-height: 8em; border: 1px solid #ccc; padding: 4px; white-space: pre-wrap; overflow: auto;">
    </span>
  </div>
</div>

<div *ngIf="showQPopup" class="modal-overlay" (click)="closeQPopup()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="ttmodal__header">
      <span class="ttmodal__title">Question</span>
      <i class="material-icons ttmodal__close-button" (click)="closeQPopup()" title="Close">close</i>
    </div>
    <span [innerText]="currentQuestion"
          style="display: inline-block; width: 70ch; min-height: 13em; border: 1px solid #ccc; padding: 4px; white-space: pre-wrap; overflow: auto;">
    </span>
  </div>
</div>
